<template>
  <div>
    <div v-if="isMobile" class="home">
      <div class="wheelSeedingPicture">
        <div class="block text-center">
          <el-carousel height="500px">
            <el-carousel-item v-for="item in carouseData" :key="item">
              <img :src="item.imgUrl" style="width: 100%; height: 100%" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="mian-section">
        <div style="margin-right: 18px;">
          <div class="titleEn">Introduction to the public appraisal service platform</div>
          <div class="title">众估宝服务平台介绍</div>
          <div class="line"></div>
          <div class="content">我们可根据保险公司的定制需求，定期或不定期地提供合作公估公司在平台上的案件服务质量数据，涉及结案时效、减损成效、投诉情况等多个方面。这些数据旨在帮助保险公司监控服务质量，优化合作效果，确保案件处理的高效与公正。</div>
          <div class="detailBtn" @click="goIntroduce">了解详情 ></div>
        </div>
        <div>
          <img src="../assets/jieshao.png" alt="">
        </div>
      </div>
      <div class="mian-section" style="border: none;">
        <div>
          <img src="../assets/sdsda@10x-8.png" alt="">
        </div>
        <div style="margin-left: 113px;">
          <div class="titleEn">Case study of Zhongweibao</div>
          <div class="title">众估宝解决方案</div>
          <div class="line"></div>
          <div class="content">聚合服务​：通过整合市场上分散的公估资源，为用户提供了个“一站式”的公估服务解决方案，解决了用户寻找合适公估公司的题。
​提升效率​：其聚合模式理论上可以优化匹配流程，帮助用户更快地找到合适的公估服务，也可能通过平台监督促进服务质量的提升。</div>
          <div class="detailBtn" @click="goCase">了解详情 ></div>
        </div>
       
      </div>
      <div class="industryNews">
        <h1 class="name">行业动态</h1>
        <div class="underline"></div>
        <div class="content">
          <div class="content-img">
            <img
              v-if="industryNewsImg"
              style="border-radius: 0px 0px 0px 10px"
              class="firstChoice"
              :src="industryNewsImg"
              alt=""
            />
            <div class="spareTire" v-if="spareTireShow">
              <img src="../assets/masking.png" alt="" />
              <div class="spareTire-title">
                <div class="spareTire-title-title">
                  {{ spareTireTitle.title }}
                </div>
                <div class="spareTire-title-underline"></div>
                <div class="spareTire-title-content">
                  {{ spareTireTitle.content }}
                </div>
              </div>
            </div>
          </div>
          <div class="content-right">
            <div
              class="content-right-concrete"
              v-for="(item, index) in industryNewsContent"
              :key="index"
              @mouseenter="enters(item)"
              @mouseleave="leaver(item)"
              @click="goSpecificNews(item)"
            >
              <div class="content-right-concrete-time">{{ item.releaseTime }}</div>
              <div class="content-right-concrete-title">
                {{ item.title }}
              </div>
              <div class="content-right-concrete-content">
                {{ item.content }}
              </div>
            </div>
          </div>
        </div>
        <div class="industryNews-seeMore" @click="goNews">查看更多</div>
      </div>
    </div>
    <div v-else>
      <div class="mswiper">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="item in carouseData" :key="item">
            <img :src="item.imgUrl" alt="" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="m-mian-section">
        <div class="titleEn">Introduction to the public appraisal service platform</div>
          <div class="title">众估宝服务平台介绍</div>
          <div class="line"></div>
          <div class="content">我们可根据保险公司的定制需求，定期或不定期地提供合作公估公司在平台上的案件服务质量数据，涉及结案时效、减损成效、投诉情况等多个方面。这些数据旨在帮助保险公司监控服务质量，优化合作效果，确保案件处理的高效与公正。</div>
          <div class="detailBtn" @click="goIntroduce">了解详情 ></div>
          <div class="img">
            <img src="../assets/jieshao.png" alt="">
          </div>
      </div>
      <div class="m-mian-section" style="border: none;">
        <div class="img">
          <img src="../assets/sdsda@10x-8.png" alt="">
        </div>
        <div class="titleEn" style="margin-top: 32px;">Case study of Zhongweibao</div>
          <div class="title">众估宝解决方案</div>
          <div class="line"></div>
          <div class="content">聚合服务​：通过整合市场上分散的公估资源，为用户提供了个“一站式”的公估服务解决方案，解决了用户寻找合适公估公司的题。
​提升效率​：其聚合模式理论上可以优化匹配流程，帮助用户更快地找到合适的公估服务，也可能通过平台监督促进服务质量的提升。</div>
          <div class="btn-wrap"><div class="detailBtn" @click="goIntroduce">了解详情 ></div></div>
      </div>
      <div class="industryDynamics">
        <div class="industryDynamics-title">行业动态</div>
        <div class="industryDynamics-img">
          <img :src="industryNewsImg" alt="" />
        </div>
        <div class="industryDynamics-content">
          <div
            class="industryDynamics-content-1"
            v-for="(item, index) in industryNewsContent"
            :key="index"
            @click="goSpecificNews(item)"
          >
            <div class="industryDynamics-content-1-title">{{ item.title }}</div>
            <div class="industryDynamics-content-1-content">
              {{ item.content }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getBanner,
  getIndustryNews,
  getArticle,
  getProjectBusiness,
  getBusinessPartner,
  getCompanyNews,
} from "../http/api/api";
import serverConfig from "../http/config/index";
import { Vue3SeamlessScroll } from "vue3-seamless-scroll";
export default {
  name: "HomeView",
  components: {
    Vue3SeamlessScroll,
  },
  data() {
    return {
      carouseData: [
        
      ],
      data: {
        page: 1,
        limit: 6,
      },
      CompanyNewsContent: [],
      mCompanyNewsContent: [],
      companyIntroductionImg: null,
      industryNewsImg: null,
      spareTireShow: false,
      industryNewsContent: [],
      spareTireTitle: null,
      projectBusiness: {},
      projectBusinessImg: null,
      BusinessPartnerImg: [],
      isMobile: false,
    };
  },
  created() {
    // this.getIndustryNews();
    this.checkDeviceType();
    window.addEventListener("resize", this.checkDeviceType);
  },
  mounted() {
    this.getCarouselMap();
   
    // this.getProjectBusiness();
    // this.getBusinessPartner();
    // this.getCompanyNews();
    this.getIndustryNewsContent();
  },
  methods: {
    goIntroduce(){
      this.$router.push({
        path: "/introduce",
      });
    },
    goCase(){
      this.$router.push({
        path: "/projectBusiness",
      });
    },
    goContent(item) {
      if (item.remark) {
        window.open(item.remark, "_blank");
      } else {
        this.$router.push({
          path: "/announcementDetails",
          query: { id: item.id },
        });
      }
    },
    goSpecificNews(item) {
      this.$router.push({
        path: "/announcementDetails",
        query: { id: item.id },
      });
    },
    goProjectBusiness() {
      this.$router.push({ path: "/projectBusiness" });
    },
    goNews() {
      this.$router.push({ path: "/newsTrends" });
    },
    enters(item) {
      this.spareTireShow = true;
      this.spareTireTitle = item;
      // console.log(this.spareTireTitle);
    },
    leaver(item) {
      this.spareTireShow = false;
    },
    getCarouselMap() {
      getBanner({companyCode: window.location.host}).then((res) => {
        
        this.carouseData = res.data;
      });
    },
    getCompanyNews() {
      let data = this.data;
      getCompanyNews(data).then((res) => {
        this.CompanyNewsContent = res.rows;
        this.mCompanyNewsContent = res.rows.slice(0, 6);
        if(this.CompanyNewsContent[0].img !== null) {
          this.companyIntroductionImg = this.CompanyNewsContent[0].img
        }
   
      });
    },
    getIndustryNews() {
      getIndustryNews().then((res) => {
        res.rows.forEach((item) => {
          if (item.type == 18) {
            this.companyIntroductionImg = serverConfig.baseURL + item.imgUrl;
          } else if (item.type == 19) {
            this.industryNewsImg = serverConfig.baseURL + item.imgUrl;
          }
        });
        console.log(res);
      });
    },
    getIndustryNewsContent() {
      getArticle({
        pageNum: 1,
        pageSize: 4,
        categoryCode: "zgb-hangye",
        companyCode: window.location.host,
      }).then((res) => {
        this.industryNewsContent = res.data.list;
        if(this.industryNewsContent[0].coverImg !== null) {
          this.industryNewsImg = this.industryNewsContent[0].coverImg
        }
      });
    },

    getProjectBusiness() {
      getProjectBusiness().then((res) => {
        console.log(999, res);
        res.data.forEach((item) => {
          this.projectBusinessImg = serverConfig.baseURL + item.imgUrl;
        });
        this.projectBusiness = res.data[0];
      });
    },
    getBusinessPartner() {
      getBusinessPartner().then((res) => {
        let data = res.rows.map((item) => {
          return { url: serverConfig.baseURL + item.imgUrl };
        });
        this.BusinessPartnerImg = data;
        console.log(this.BusinessPartnerImg, 777);
      });
    },
    checkDeviceType() {
      const userAgent = navigator.userAgent.toLowerCase();
      const minWidthForMobile = 768;
      if (
        userAgent.match(
          /(android|iphone|ipad|ipod|webos|blackberry|iemobile|opera mini)/i
        )
      ) {
        this.isMobile = false;
      } else if (window.innerWidth < minWidthForMobile) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  padding-bottom: 100px;
}
.wheelSeedingPicture {
  margin-bottom: 79px;
}
.mian-section{
  margin: 0 105px;
  margin-top: 90px;
  display: flex;
  border-bottom: 2px solid #AC2124;
  padding-bottom: 91px;
  .titleEn{
    font-size: 16px;
    color: #AC2124;
    letter-spacing: 3px;
  }
  .title{
    color: #333333;
    font-size: 48px;
    font-weight: bold;
    margin-top: 20px;
  }
  .line{
    width: 188px;
    height: 2px;
    background: #AC2124;
    margin-top: 20px;
  }
  .content{
    margin-top: 31px;
    color: #666666;
    font-size: 16px;
    text-indent: 2em;
    line-height: 34px;
    padding-right: 39px;
  }
  .detailBtn{
    margin-top: 80px;
    width: 127px;
    height: 45px;
    text-align: center;
    line-height: 48px;
    background-color: #AC2124;
    color: #fff;
    border-radius: 7px;
    cursor: pointer;
  }
  .img-wrap{
    display: flex;
    align-items: center;
  }
  img{
    width: 423px;
    height: 372px;
  }
}
.m-mian-section{
  margin: 0 27px;
  margin-top: 34px;
  border-bottom: 2px solid #AC2124;
  padding-bottom: 60px;
  .titleEn{
    font-size: 10px;
    color: #AC2124;
    letter-spacing: 1px;
  }
  .title{
    color: #333333;
    font-size: 28px;
    font-weight: bold;
    margin-top: 16px;
  }
  .line{
    width: 126px;
    height: 2px;
    background: #AC2124;
    margin-top: 20px;
    margin-left: 10px
  }
  .content{
    margin-top: 31px;
    color: #666666;
    font-size: 14px;
    text-indent: 2em;
    line-height: 34px;
  }
  .detailBtn{
    margin-top: 23px;
    width: 127px;
    height: 45px;
    text-align: center;
    line-height: 48px;
    background-color: #AC2124;
    color: #fff;
    border-radius: 7px;
    font-size: 16px;
  }
  .img{
    width: 100%;
    margin-top: 18px;
    img{
      width: 100%;
    }
  }
  .btn-wrap{
    display: flex;
    justify-content: flex-end;
  }
}
.companyIntroduction {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 90px;
  .name {
    font-size: 36px;
    font-weight: 800;
    color: #C1191F;
    letter-spacing: 8px;
    margin-bottom: 40px;
  }
  .content {
    display: flex;
    align-items: center;
    .content-img {
      width: 580px;
      height: 400px;
      margin-right: 29px;
      // background-color: red;
      border-radius: 0px 20px 0px 20px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 0px 20px 0px 20px;
      }
    }
    .content-right {
      width: 580px;
      height: 400px;
      .content-title {
        font-size: 28px;
        font-weight: 500;
        color: #262626;
        margin-left: 15px;
      }
      .underline {
        width: 100%;
        height: 1px;
        background: #bbbbbb;
        margin-top: 6px;
        margin-bottom: 25px;
      }

      .newsContents {
        height: 82%;
        overflow: hidden;
        .newsContent {
          display: flex;
          justify-content: space-between;
          margin-bottom: 30px;
          cursor: pointer;
          .newsContent-title {
            width: 330px;
            font-size: 20px;
            font-weight: 400;
            color: #333333;
            display: flex;
            align-items: center;
            margin-left: 10px;
          }
          .newsContent-time {
            font-size: 20px;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
          }
        }
        .newsContent:hover {
          .newsContent-title {
            color: #C1191F;
            font-size: 23px;
            line-height: 26px;
          }
          .newsContent-time {
            color: #C1191F;
            font-size: 23px;
            line-height: 26px;
          }
        }
      }
    }
  }
}
.industryNews {
  // margin-top: 100px;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  .name {
    font-size: 28px;
    font-weight: 500;
    color: #262626;
    margin-bottom: 6px;
    margin-left: 15px;
  }
  .underline {
    width: 1197px;
    height: 1px;
    background: #dddddd;
  }
  .content {
    width: 100%;
    height: 500px;
    margin-top: 30px;
    display: flex;
    .content-img {
      width: 840px;
      height: 500px;

      position: relative;
      .firstChoice {
        width: 100%;
        height: 100%;
        position: absolute;
      }

      .spareTire {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 999;
        img {
          width: 100%;
          height: 100%;
          position: absolute;
        }
        .spareTire-title {
          position: absolute;
          bottom: 0;
          width: 90%;
          left: 50%;
          transform: translate(-50%, 0);
          padding-bottom: 30px;
          box-sizing: border-box;
          .spareTire-title-title {
            font-size: 30px;
            font-weight: 500;
            color: #ffffff;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .spareTire-title-underline {
            width: 94px;
            height: 4px;
            background: #ffffff;
            margin: 15px 0;
          }
          .spareTire-title-content {
            width: 100%;
            font-size: 14px;
            font-weight: 500;
            color: #f3f2f2;
            line-height: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
        }
      }
      // background: url(../assets/industryNewsPicture.png) no-repeat 0 0;
      // /* 图片可以保有其原有的尺寸，或者拉伸到新的尺寸，或者在保持其原有比例的同时缩放到元素的可用空间的尺寸。 */
      // background-size: cover;
    }
    .content-right {
      width: 362px;
      display: flex;
      flex-direction: column;
      .content-right-concrete {
        height: 25%;
        display: flex;
        flex-direction: column;
        padding-left: 10px;
        border: 1px solid #efefef;
        cursor: pointer;
        .content-right-concrete-time {
          font-size: 16px;
          font-weight: 400;
          color: #666666;
          margin: 15px 0px 5px 0px;
        }
        .content-right-concrete-title {
          width: 80%;
          font-size: 20px;
          font-weight: 500;
          color: #333333;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-bottom: 10px;
        }
        .content-right-concrete-content {
          width: 90%;
          font-size: 14px;
          font-weight: 500;
          color: #999999;
          line-height: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
      }
      .content-right-concrete:nth-child(-n + 3) {
        border-bottom: 0;
      }
      .content-right-concrete:hover {
        background-color: rgba(220, 16, 16, 0.1);
        border-right: 7px solid #C1191F;
      }
    }
  }
  .industryNews-seeMore {
    width: 201px;
    height: 44px;
    border: 1px solid #C1191F;
    border-radius: 22px;
    font-size: 18px;
    font-weight: 400;
    color: #C1191F;
    line-height: 44px;
    text-align: center;
    cursor: pointer;
    letter-spacing: 5px;
    margin: 0 auto;
    margin-top: 83px;
  }
}

.advertisingCenter {
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .name {
    font-size: 36px;
    font-weight: 800;
    color: #C1191F;
    letter-spacing: 8px;
    margin: 0;
    margin-bottom: 65px;
  }
  .advertisingCenter-b {
    display: flex;
    flex-direction: row-reverse;
    width: 100%;
    position: relative;
    .advertisingCenter-content {
      width: 612px;
      height: 372px;
      background-color: rgba(255, 255, 255);
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      border-radius: 5px;
      box-shadow: -1px 1px 10px 1px #e8e8e8;
      display: flex;
      flex-direction: column;
      align-items: center;
      .advertisingCenter-content-title {
        font-size: 39px;
        font-weight: bold;
        color: #333333;
        margin: 40px 0px 23px 0px;
      }

      .advertisingCenter-content-underline {
        width: 94px;
        height: 3px;
        background: #333333;
      }

      .advertisingCenter-content-content {
        width: 80%;
        font-size: 16px;
        font-weight: 400;
        margin: 35px 0px 30px 0px;
        color: #333333;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 5;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }

      .advertisingCenter-content-seeMore {
        width: 201px;
        height: 44px;
        background-color: #C1191F;
        border-radius: 22px;
        font-size: 18px;
        font-weight: 400;
        color: #fff;
        line-height: 44px;
        text-align: center;
        cursor: pointer;
        letter-spacing: 5px;
        margin: 0 auto;
      }
    }
    .advertisingCenter-img {
      width: 760px;
      height: 530px;
      background-color: black;
      border-radius: 20px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 20px;
      }
    }
  }
}
.businessPartner {
  margin-top: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .name {
    font-size: 36px;
    font-weight: 800;
    color: #C1191F;
    letter-spacing: 8px;
    margin: 0;
    margin-bottom: 40px;
  }
  .businessPartnerContent {
    width: 100%;
    // display: flex;

    // justify-content: space-between;
    overflow-x: hidden;
    .businessPartnerName {
      width: 270px;
      height: 110px;
      border-radius: 5px;
      box-shadow: -1px 1px 10px 1px #e8e8e8;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 30px;
      margin-left: 5px;
      margin-top: 15px;
      margin-bottom: 5px;
      transition: all 0.5s;
      img {
        width: 80%;
      }
    }
    .businessPartnerName:hover {
      transform: translateY(-10px);
    }
  }
}

.my-swipe .van-swipe-item {
  width: 100%;
  height: 53.3333vw;
  img {
    width: 100%;
    height: 100%;
  }
}

.mCompanyNews {
  margin-top: 5.3333vw;
  .mCompanyNews-title {
    display: flex;
    justify-content: center;
    font-size: 5.5vw;
    font-weight: 500;
    color: #262626;
    padding-bottom: 1.3333vw;
    margin-bottom: 1.3333vw;
  }
  .mCompanyNews-img {
    width: 85vw;
    height: 55vw;
    border-radius: 0px 20px 0px 20px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
      border-radius: 0px 20px 0px 20px;
    }
  }

  .mCompanyNews-content {
    width: 90vw;
    margin: 0 auto;

    .mCompanyNews-content-1 {
      margin-left: 3vw;
      .mCompanyNews-content-1-title {
        display: flex;
        align-items: center;
        width: 100%;
        font-size: 4.2667vw;
        margin-left: 1.3333vw;
        margin: 2.6667vw 0px;
      }
    }

  }
}

.industryDynamics {
  margin-top: 5.3333vw;
  .industryDynamics-title {
    display: flex;
    justify-content: center;
    font-size: 5.5vw;
    font-weight: 500;
    color: #262626;
    padding-bottom: 1.3333vw;
    margin-bottom: 1.3333vw;
  }
  .industryDynamics-img {
    width: 85vw;
    height: 53vw;
    border-radius: 0px 20px 0px 20px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
      border-radius: 0px 20px 0px 20px;
    }
  }
  .industryDynamics-content {
    width: 85vw;
    margin: 0 auto;
    margin-top: 2.6667vw;
    .industryDynamics-content-1 {
      padding: 0.8vw 4vw;
      box-shadow: -1px 1px 10px 1px #efefef;
      margin-top: 2.6667vw;
      &.industryDynamics-content-1:nth-child(-n + 3) {
        border-bottom: 0px;
      }
      .industryDynamics-content-1-title {
        width: 90%;
        font-size: 4.8vw;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .industryDynamics-content-1-content {
        width: 95%;
        font-size: 3.2vw;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        color: #999999;
      }
    }
  }
}

.mseeMore {
  width: 40vw;
  height: 9.3333vw;
  border: 1px solid #C1191F;
  border-radius: 5.8667vw;
  font-size: 4.8vw;
  font-weight: 400;
  color: #C1191F;
  line-height: 9.3333vw;
  text-align: center;
  margin: 0 auto;
  margin-top: 5.3333vw;
}
</style>